module.exports = __webpack_public_path__ + "static/media/logo-lbi.920043e2.svg";